import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Input from 'components/Input'
import StrengthMeter from './StrengthMeter'
import { noop } from 'utils'
import styled from 'styled-components'
import { IconButton } from 'components/Button'

import { ReactComponent as EyeIcon } from 'icons/eye-20.svg'

const StrengthMeterContainer = styled.div`
  position: absolute;
  bottom: 4px;
  left: 4px;
  right: 4px;
  height: 2px;
  overflow: hidden;
  border-radius: 0 0 1px 1px; /* stylelint-disable-line scales/radii */
`

const TogglePasswordButton = styled(IconButton).attrs({
  type: 'button',
  size: '20px',
})`
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
`

class PasswordInput extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showPassword: false,
    }

    this.input = null
  }

  toggleShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword })
    this.input.focus()
  }

  bindInput = input => {
    this.props.inputRef(input)
    this.input = input
  }

  render() {
    const {
      strengthMeter,
      className,
      style,
      disabled,
      inputStyle,
      value,
      ...props
    } = this.props
    const { showPassword } = this.state
    const inputProps = { disabled, inputStyle, ...props }

    return (
      <div className={className} style={style}>
        <Input
          data-testid="input"
          type={showPassword ? 'text' : 'password'}
          ref={this.bindInput}
          {...inputProps}
        />
        {!disabled && (
          <TogglePasswordButton
            data-testid="eye-icon"
            active={showPassword}
            icon={EyeIcon}
            onClick={this.toggleShowPassword}
            tabIndex={-1}
          />
        )}
        {strengthMeter && (
          <StrengthMeterContainer>
            <StrengthMeter value={value || ''} />
          </StrengthMeterContainer>
        )}
      </div>
    )
  }
}

PasswordInput.propTypes = {
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  onChange: PropTypes.func,
  strengthMeter: PropTypes.bool,
  inputRef: PropTypes.func,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  style: PropTypes.object,
  inputStyle: PropTypes.object,
}

PasswordInput.defaultProps = {
  onChange: noop,
  inputRef: noop,
}

const StyledPasswordInput = styled(PasswordInput)`
  position: relative;

  ${Input} {
    padding-right: 2.5rem; /* stylelint-disable-line scales/space */
  }
`

export default StyledPasswordInput
